export const styles = {
  card: { padding: '2.5rem', marginBottom: '2rem' },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    marginTop: '1rem',
    marginBottom: '2rem',
  },
  input: {
    margin: '20px 0',
  },
  dropzone: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '34px',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/Clients/ClientForm/styles.js